export default __webpack_public_path__ + "static/media/banner-seguro-empresarial-mobile.4472be48.png";